import useTracksStore from '../../../../shared/store/tracks.store.tsx'
import type { Clip } from '../models/clip.ts'
import { recordChange } from './record-change.ts'
import { selectClip } from '@/features/clips/domain/use-cases/select-clip.ts'

export const updateClip = (id: string, clip: Partial<Clip>): void => {
  useTracksStore.getState().updateClip(id, clip)
  selectClip(undefined)
  recordChange()
}
